module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_List_Propotions#fm-1"
    }
  }, [_vm._v("List of Propositions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface#fm-2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbrevation#fm-3"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fm-4"
    }
  }, [_vm._v("Introduction: Point of View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-1"
    }
  }, [_vm._v("Augustinian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-2"
    }
  }, [_vm._v("Protestant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-3"
    }
  }, [_vm._v("Liberal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-4"
    }
  }, [_vm._v("Augustinian, Protestant, and Liberal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-5"
    }
  }, [_vm._v("Humanist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Part01#pt-1"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("METHOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("A Conception of Christian Theology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-6"
    }
  }, [_vm._v("Mystery and Sensibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-7"
    }
  }, [_vm._v("Religious Communities and Interpretive Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-8"
    }
  }, [_vm._v("Varieties of Theological Visions (or Wisdoms)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-9"
    }
  }, [_vm._v("Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-10"
    }
  }, [_vm._v("Christian Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Formation and Arrangement of Theological Statements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Formation of Theological Statements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arrangement of Theological Statements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("CREATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Constitution of the Dynamic World: Cosmic Ecology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Creator-Redeemer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World as Created")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Dynamic Continuation of the World: Cosmic Passage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Providence and Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Particularity and Plurality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Decalogue and Natural Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosmological Implications of Modern Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rethinking Our Theatrical Imagery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Characteristics of Cosmic Passage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Unscientific Postscript for a Scientific Age")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Calvinist Vocabulary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s at Stake Practically")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reenvisioning Destiny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Created and Sustained Human Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Humans Are Socially Inclined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Institutions Sustain by Furnishing Critical Goods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distinctive Powers and Capacities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capacity Implies Distinctive Responsibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Limitations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responsive Participants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Apprehend Ourselves as Persons Narratively")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Apprehend Ourselves as Persons Practically")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Apprehend Ourselves as Persons in the Midst of Encounters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persons before God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Pursue Ends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Chief End and Calling in the Midst of Cosmic Ecology and Passage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How We Participate in the Wider Cosmos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living in the Face of Mystery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("God the Creator")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical Roots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Negative Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical Depictions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theologies of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Critical Points")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A More Rough-and-Ready Vocabulary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creation and Governance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosmic Passage and Emergence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Unifying Reign, or Trajectory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deity at Work in Cosmic Passage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Is the Real")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Encompassing Tendency of the Real Bears on Us as a Dynamic Order of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dynamic Ordering of Grace Pushes Us toward an Ec-centric Orientation in Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("REDEMPTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Jesus Christ and the Covenant of Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Covenant of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Intricacies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Observations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stepping beyond Barth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s New?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Expansion and a Revision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus on the Image of God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sensing the Gratuitous Heart of Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus on Christology and History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Inexhaustible and Multifaceted Theme")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cosmic Resonance and Reference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reconciler Also Judges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus on Christological Doctrine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Truth, the Way, and the Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love God, Your Neighbor, and Even Your Enemies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crucifixion and Atonement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Spirit and the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#sec-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Initial Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#sec-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit Orients and Directs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#sec-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Contemporary Restatement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#sec-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Word")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#sec-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Human Life: Sin and Regeneration")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall and Original Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radical and Universal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Original?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luther and Calvin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Luther and Calvin Go Wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reinterpreting Justification by Grace through Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why the Reinterpreted and Revised Idea Is Relevant, Even Subversive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Alteration in Our Motives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpreting and Reinterpreting Moral Norms and Commands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Impetus toward Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liturgical Expressions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coherence and Complexity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mingling Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spouses, Parents, Physicians, and Soldiers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#sec-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protestant Differences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("The Fragmentation and Renewal of the World: Civil Government, Church, and Sustainability")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calvin’s Reformation Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Updating Calvin’s View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Standards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Demonic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conflicting Dynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church "), _c('em', [_vm._v("in")]), _vm._v(" the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church "), _c('em', [_vm._v("with")]), _vm._v(" the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church "), _c('em', [_vm._v("against")]), _vm._v(" the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church "), _c('em', [_vm._v("for")]), _vm._v(" the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planetary-Scale Thinking, Human Responsibility and Limits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#sec-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prospects for Sustainability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("God the Redeemer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#sec-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus as the Christ and the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#sec-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Creator, Judge, and Redeemer Is the God of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#sec-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future Developments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#sec-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastoral, Political, and Spiritual Dimensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#sec-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Eschatological Views")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Sense the Trinity Makes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Epilogue#sec-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biblically Initiated Exploration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Epilogue#sec-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Courage to Live Ec-centrically in God’s World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Epilogue#sec-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Threefold Apprehension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Select_List#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select List of Works Consulted")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8f4adb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0